import { IdName } from 'src/app/shared/models/id-name';
import { IUserChemicalExposureLogItem } from '../models/chemical-exposure.model';
import { chemicalExposurePersonId } from './chemical-exposure-person-id';

export function chemicalExposureLogUsers(item: IUserChemicalExposureLogItem): IdName[] {
  if (item.exposedUsers?.length) {
    return item.exposedUsers;
  }

  return (item.exposedPersons ?? [])
    .map((person) => ({
      id: chemicalExposurePersonId(person),
      name: person.name,
    }))
    .filter((person) => !!person.id);
}
